import { PropsWithChildren, Suspense, useEffect, useState } from "react";

import { useUserContext } from "@/components/user-context";
import { useGupsStatus } from "@/templates/ondemand/signup/confirmation/confirmation-page/src/hooks/use-gups";

import { HeroCTASkeleton } from "./hero-cta-skeleton";

export const LoggedInHeroContainer = ({ children }: PropsWithChildren) => {
    const {
        profile: { requestInProgress: profileRequestInProgress },
        user: { requestInProgress: userRequestInProgress }
    } = useUserContext();

    const [userProfileInProgress, setUserProfileInProgress] = useState(true);

    const { getUserProfileJobFunctionCallback } = useGupsStatus();

    useEffect(() => {
        getUserProfileJobFunctionCallback("homepage-xflow").then((response) => {
            setUserProfileInProgress(response?.requestInProgress);
        });
    }, [getUserProfileJobFunctionCallback]);

    const isBrowser = typeof window !== "undefined";
    if (!isBrowser) {
        return <HeroCTASkeleton />;
    }

    // Checking for both user and profile request in progress,
    // since profileRequestInProgress is initially defined as 'false' and then gets updated to true when the request is made.
    if (
        userRequestInProgress ||
        profileRequestInProgress ||
        userProfileInProgress
    ) {
        return <HeroCTASkeleton />;
    }

    return <Suspense fallback={<HeroCTASkeleton />}>{children}</Suspense>;
};

LoggedInHeroContainer.displayName = "LoggedInHeroContainer";
